
































import Vue from 'vue'
export default Vue.extend({
  props: {
    customClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 999999
    },
    quantitySuggest: {
      type: Array as () => number[],
      default: () => []
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    maxValueKey: number,
    showSuggestion: boolean,
    inputSelect: string
  } {
    return {
      maxValueKey: 0,
      showSuggestion: false,
      inputSelect: ''
    }
  },
  computed: {
    suggestionState(): boolean {
      return this.showSuggestion && this.searchSelect.length > 0
    },
    inputValue(): number {
      if (!this.maxValue) return this.value
      return Math.min(this.maxValue, this.value)
    },
    validateInput(): number | undefined {
      return (this.value === 0 ) ? undefined : this.inputValue
    },
    validateNaNInput(): number | string {
      return isNaN(this.value) ? this.$refs?.numberInput?.value : this.validateInput
    },
    hasError(): boolean {
      return isNaN(this.value == undefined ? 0 : this.value)
    },
    searchSelect(): number[] {
      let newSuggest: number[] = []
      if (this.quantitySuggest.length > 0) {
        let element = this.inputValue.toString()
        newSuggest = this.quantitySuggest.filter(user =>
          user.toString().includes(element)
        )
      }
      return newSuggest
    }
  },
  methods: {
    toggleSuggestion(state: boolean) {
      this.showSuggestion = state
    },
    maxValidate(value: number): number {
      if (!isNaN(value)) {
        if (value > this.maxValue) {
          this.maxValueKey = this.maxValueKey + 1
          return this.maxValue
        }
      }
      return value
    },
    input(event: any){
      this.$emit('input', Number(this.maxValidate(event.target.value)))
    },
    validateNumberInput(input: any) {
      if (isNaN(Number(input.key))) {
        return input.preventDefault()
      }
    },
    selectQuantity(input: number){
      this.$emit('input', input)
      this.toggleSuggestion(false)
    }
  }
})
